import React from "react";
import PropTypes from "prop-types";

const SupervisorAwardIcon = ({ fill, width, height, boxShadow }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M81.6761 58.9344L87.7596 55.4221L84.0328 48.9672L89 44L84.7647 39.7647L88.4667 33.3526L82.055 29.6509L83.9711 22.4996L75.4056 20.2045V13.1803H69.4163L67.5 6.02861L60.3485 7.94484L56.6469 1.53334L50.2351 5.23514L45 0L39.7652 5.23483L34.5779 2.23995L31.0655 8.32361L23.866 6.39452L22.0478 13.1803H13.1802V20.5836L7.39491 22.1337L9.21308 28.9192L2.75809 32.646L6.27042 38.7296L1 44L7.00228 50.0023L3.46519 56.1287L9.59198 59.666L7.76091 66.4996L13.1802 67.9517V75.4057H21.6691L23.5 82.2388L30.3334 80.4079L33.8708 86.5348L39.9975 82.9975L45 88L50.0028 82.9972L57.354 87.2414L61.0806 80.7866L67.866 82.6048L69.795 75.4057H75.4056V68.3308L83.6051 66.1337L81.6761 58.9344Z"
        fill={fill}
      />
      <mask
        id="mask0"
        maskUnits="userSpaceOnUse"
        x="8"
        y="7"
        width="74"
        height="76"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.7817 7.15909C62.5575 7.15909 77.0746 18.1568 81.5096 35.7955H8.05372C12.4887 18.1568 27.0058 7.15909 44.7817 7.15909ZM44.7817 82.8409C62.5575 82.8409 77.0746 71.8432 81.5096 54.2046H8.05371C12.4887 71.8432 27.0058 82.8409 44.7817 82.8409Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.5542 45C79.5542 64.2045 63.986 79.7727 44.7815 79.7727C25.5771 79.7727 10.0088 64.2045 10.0088 45C10.0088 25.7956 25.5771 10.2273 44.7815 10.2273C63.986 10.2273 79.5542 25.7956 79.5542 45ZM44.7815 77.7273C62.8563 77.7273 77.5088 63.0748 77.5088 45C77.5088 26.9252 62.8563 12.2727 44.7815 12.2727C26.7067 12.2727 12.0542 26.9252 12.0542 45C12.0542 63.0748 26.7067 77.7273 44.7815 77.7273Z"
          fill="white"
        />
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.4862 45C76.4862 62.5099 62.2916 76.7045 44.7817 76.7045C27.2718 76.7045 13.0771 62.5099 13.0771 45C13.0771 27.4901 27.2718 13.2955 44.7817 13.2955C62.2916 13.2955 76.4862 27.4901 76.4862 45ZM44.7817 74.6591C61.162 74.6591 74.4408 61.3803 74.4408 45C74.4408 28.6197 61.162 15.3409 44.7817 15.3409C28.4014 15.3409 15.1226 28.6197 15.1226 45C15.1226 61.3803 28.4014 74.6591 44.7817 74.6591Z"
          fill="white"
        />
      </g>
      <path
        d="M18.4094 43.5402L13.9974 43.1397L12.2731 38.8636L10.5488 43.1462L6.13672 43.5402L9.48717 46.5955L8.48081 51.1364L12.2731 48.727L16.0654 51.1364L15.0651 46.5955L18.4094 43.5402Z"
        fill="white"
      />
      <path
        d="M83.8635 43.5402L79.4515 43.1397L77.7272 38.8636L76.0029 43.1462L71.5908 43.5402L74.9413 46.5955L73.9349 51.1364L77.7272 48.727L81.5195 51.1364L80.5192 46.5955L83.8635 43.5402Z"
        fill="white"
      />
      <path
        d="M49.0312 27.5427C40.1233 23.7921 36.2554 31.9968 37.0758 37.0367C35.2005 37.0367 37.0037 40.4516 37.7791 42.4284C39.1388 45.8947 39.6545 48.9922 44.6945 48.9922C49.7345 48.9922 51.7271 42.4284 51.7271 42.4284C51.7271 42.4284 54.4229 39.3809 52.7819 37.154C53.6259 34.7161 53.6024 31.1763 51.7271 29.6524C51.0238 29.1837 50.2033 28.9493 49.0312 27.5427Z"
        fill="white"
      />
      <path
        d="M30.9809 51.6881C32.8563 50.9379 37.0758 48.9532 38.9512 48.0546L42.4675 59.8756L43.9912 55.0872C43.9912 55.0872 40.984 51.2718 42.6019 50.6332C43.2406 50.3811 46.5 50.3811 47.1387 50.6332C48.7566 51.2718 45.7494 55.0872 45.7494 55.0872L47.1559 59.8756L50.4378 48.0546C50.4378 48.0546 55.8295 50.6332 58.2909 51.6881C60.7523 52.743 60.7523 55.3216 60.7523 55.3216C60.7523 55.3216 54.4229 63.4091 44.6945 63.4091C34.9661 63.4091 28.6367 55.3216 28.6367 55.3216C28.6367 54.423 29.1056 52.4382 30.9809 51.6881Z"
        fill="white"
      />
    </svg>
  );
};

SupervisorAwardIcon.propTypes = {
  /**
   * The color of the award icon
   * Can be any CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
   */
  fill: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  boxShadow: PropTypes.bool
};

SupervisorAwardIcon.defaultProps = {
  width: "75%",
  height: 114,
  boxShadow: true
};

export default SupervisorAwardIcon;
